import navtabs from './navtabs' //共通元件状态
import lidaTable from './lidaTable'
import liveshow from './liveshow'
import allGame from './allGame'
import user from './user'
import drawReload from './drawReload'

export default {
  navtabs,
  lidaTable,
  liveshow,
  allGame,
  user,
  drawReload
}